<article class="pager" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header>
    <div class="process">
      <sot-stepper activeStep="pager"></sot-stepper>
    </div>
  </header>
  <div class="content">
    <div class="box">
      <ng-container>
        <h3 langkey="callsystem_use_pager">Pager mitnehmen</h3>
        <div class="icon" inlineSVG="sot/sot-icon.svg#sot-pagerscan_square" [setSVGAttributes]="{class: 'box-icon'}">
        </div>
        <p langkey="callsystem_use_pager_text">Pager unten aus dem Fach nehmen</p>
      </ng-container>
      <footer>
        <a class="btn clear" (click)="openManualPagerInput()" langkey="callsystem_enter_manually">Alternativ Nummer
          eingeben</a>
      </footer>
      <div class="downpay" inlineSVG="sot/sot-icon.svg#sot-down_arrows" [setSVGAttributes]="{class: 'arrows'}"></div>
    </div>
  </div>
  <footer>
    <div class="footer-btn">
      <sot-backbtn (click)="back()"></sot-backbtn>
    </div>
  </footer>
</article>